import styled from 'styled-components';
import ProcessingImg from 'images/loader-green.gif';
import { SIZES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import Text from 'components/base/Text';
import { Flex, Padding } from 'components/base/layout-components';
import { Separator, SmallSeparator } from 'components/Separators';
import collaborationBell from 'images/characters/collaboration-bell.svg';
import characterSunglassesWithLine from 'images/characters/character-sunglasses-with-line.svg';
import { redirectToSlack } from 'common/services/slack.service';
import slackLogo from 'images/logos/slack-logo.svg';
import * as TrackingService from 'common/services/tracking.service';
import { TRACKING } from 'common/constants/constants';
import Icon from 'components/base/Icon';
import { LBButton } from '@linearb/buzz';

const COLLABOARAION_MAP = {
  SLACK: {
    name: 'Slack',
    logo: slackLogo,
    onClick: (
      selectedTeamId,
      isCollaborationConnected,
      collaborationAsFirstStep
    ) => {
      TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
        page: TRACKING.PAGES.DASHBOARD,
        click_type: TRACKING.CLICK.CONNECT_SLACK,
        slack_first_step: collaborationAsFirstStep
      });
      redirectToSlack(
        null,
        null,
        false,
        selectedTeamId
          ? `/dashboard?postSlackReAuth=${!isCollaborationConnected}`
          : '/settings/slack?isOrgSettings=true'
      );
    }
  }
};

const LogoIcon = styled.img`
  width: 1.7rem;
  height: 1.7rem;
`;

const ProcessingAnim = styled.img`
  padding-left: 1.5rem;
  height: 2.5rem;
`;

const Character = styled.img`
  padding-right: 1rem;
  height: 3.5rem;
  ${({ size }) =>
    size ? `height: ${size}; padding-top: 0.3rem;` : 'padding-top: 1rem;'}
  ${({ paddingTopBottom }) =>
    paddingTopBottom
      ? `padding-top: ${paddingTopBottom}; padding-bottom: ${paddingTopBottom};`
      : ''}
`;

const Link = styled.div`
  padding-left: 1.5rem;
  color: ${getColor('lightMelrose')};
  cursor: pointer;
  :hover {
    text-decoration: underline;
    color: ${getColor('melrose')};
  }
`;

const CollaborationButton = ({ text, logo, onClick }) => (
  <LBButton size='sm' variant='outline' onClick={onClick}>
    <LogoIcon src={logo} alt='' /> {text}
  </LBButton>
);

const PmButton = ({ pm }) => (
  <Padding r='small' key={pm.text}>
    <LBButton onClick={pm.onClick}>
      <LogoIcon src={pm.logo} alt='' /> {pm.text}
    </LBButton>
  </Padding>
);

export const ProcessingInProgress = ({ isProcessing, processingText }) => {
  if (!isProcessing) {
    return null;
  }
  return (
    <>
      <ProcessingAnim src={ProcessingImg} alt='Processing...' />
      <Text pl={SIZES.large} size='medium' color='white'>
        {processingText}
      </Text>
      <Separator />
    </>
  );
};

const MainText = ({ text, isProcessing }) => (
  <Text size={isProcessing ? 'medium' : 'large'} color='white' pr='1.5rem'>
    {text}
  </Text>
);

export const getDefaultSections = ({ isProcessing, text }) => [
  <Character src={characterSunglassesWithLine} key={`char_${text}`} />,
  <Flex items='center' key={`text_${text}`}>
    <MainText text={text} isProcessing={isProcessing} />
  </Flex>
];

export const getPMSections = ({
  isProcessing,
  text,
  jiraButton,
  clubhouseButton,
  azureBoardsButton,
  link
}) => [
  <Character src={characterSunglassesWithLine} key={1} />,
  <Flex items='center' key={2}>
    <MainText text={text} isProcessing={isProcessing} />
    {[jiraButton, clubhouseButton, azureBoardsButton]
      .filter(Boolean)
      .map(pm => (
        <PmButton pm={pm} key={pm.text} />
      ))}

    {link && <Link onClick={link.onClick}>{link.text}</Link>}
  </Flex>
];

export const getConnectCollaborationsSections = ({
  isSlackConnected,
  selectedTeamId,
  collaborationAsFirstStep
}) => [
  /* eslint-disable react/jsx-key */
  <Character src={collaborationBell} size='3rem' paddingTopBottom='0.9rem' />,
  <Flex items='center'>
    <Text size='large' color='white' pr='1.5rem'>
      Get notified about your stuck work, high interaction pull requests and
      more
    </Text>
    <SmallSeparator space='2.5' />
    <Text size='medium' color='white' pr='1.5rem'>
      Connect:
    </Text>
    {Object.values(COLLABOARAION_MAP).map(({ name, logo, onClick }) => (
      <CollaborationButton
        key={name}
        text={name}
        logo={logo}
        onClick={() =>
          onClick(selectedTeamId, isSlackConnected, collaborationAsFirstStep)
        }
      />
    ))}
  </Flex>
];
/* eslint-enable react/jsx-key */

export const ButtonDontShowAgain = props => (
  <LBButton {...props}>
    <Icon name='close' color='white' /> I don't use these tools
  </LBButton>
);
